import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactFormElevated';
import ParallaxBackground from '../components/ParallaxBackground';

const DIYRealEstate = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen"
    >
      <ParallaxBackground 
        image="/images/benjamin-franklin-bridge.jpg"
        className="py-32"
        overlay={true}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
            DIY Real Estate Sales and Purchases
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
            Expert support for DIY real estate transactions
          </p>
        </div>
      </ParallaxBackground>

      <section className="py-16 bg-eagle-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-eagle-dark mb-4">
              DIY Real Estate Sales and Purchases Services
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Engaging in a DIY real estate transaction can be an empowering experience, but it\'s essential to have professional assistance to ensure a smooth and successful outcome. At Eagle Closing, we offer specialized services for individuals undertaking DIY real estate sales and purchases, providing expert guidance and support throughout the process.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Consultation and Advice',
                description: 'Our experienced professionals are available to provide consultation and advice tailored to your specific DIY real estate transaction. We can offer insights on market trends, pricing, negotiation strategies, and legal considerations to help you make informed decisions.',
              },
              {
                title: 'Document Review',
                description: 'We meticulously review the contracts and legal documents associated with your DIY real estate transaction, ensuring that all terms and conditions are accurately reflected and in compliance with local laws and regulations. We offer guidance on any necessary revisions or additions to protect your interests.',
              },
              {
                title: 'Title Examination',
                description: 'We conduct a thorough title examination to identify any potential issues or encumbrances that may affect the property\'s ownership. This step helps ensure that you have a clear understanding of the property\'s history and any potential risks.',
              },
              {
                title: 'Closing Assistance',
                description: 'As your trusted partner, we assist in coordinating the closing process, including the preparation and review of closing documents. We ensure that all necessary paperwork is properly executed and facilitate a smooth transfer of ownership between parties.',
              },
              {
                title: 'Communication and Support',
                description: 'We act as a central point of contact, facilitating clear communication between all parties involved in the transaction. Our team is available to answer your questions, address any concerns, and provide guidance throughout the process.',
              },
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-eagle-dark mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 mb-8">
              By utilizing our DIY real estate services, you can navigate the complexities of your transaction with confidence and peace of mind. Our goal is to support you in achieving a successful real estate sale or purchase, providing the necessary expertise and resources to make your DIY journey a smooth one.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              Contact us today to learn more about our DIY real estate services and how we can assist you in achieving a successful closing. Trust Eagle Closing to be your reliable partner throughout your DIY real estate journey, ensuring a smooth and seamless transaction.
            </p>
          </div>
        </div>
      </section>
      
      {/* Contact Form with Parallax */}
      <ContactForm backgroundImage="/images/benjamin-franklin-bridge.jpg" />
    </motion.div>
  );
};

export default DIYRealEstate;

